import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { RootService } from '@app/core/root.service';

@Component({
  selector: 'app-assign-apps',
  templateUrl: './assign-apps.component.html',
  styleUrls: ['./assign-apps.component.scss'],
})
export class AssignAppsComponent implements OnInit {
  service: RootService;
  notFoundApp: boolean = true;
  appList: any = [];
  selectedApp: any = [];
  disableSubmitButton:boolean=true;
  constructor(
    private api: ApiRequestService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialogRef: MatDialogRef<AssignAppsComponent>,
  ) {
    this.service = this.data.service;
  }

  ngOnInit(): void {
    this.loadAppsList();
  }

  getAssetItem(id: any) {
    this.api.get(`admin/${this.service.moduleName}/${id}`).subscribe((res) => {
      res.data.applications.forEach((element: any) => {
        let app = this.appList.find((app: any) => app.id == element.id);
        if (app) {
          app['check'] = true;
          this.selectedApp.push(app.id);
        }
      });
    });
  }

  loadAppsList() {
    this.api.get('admin/applications?status=1').subscribe((apps: any) => {
      if (apps.data.length) {
        this.appList = apps.data;
        this.data.row && this.getAssetItem(this.data.row.id);
        this.service.selectedItems.length == 1 && this.getAssetItem(this.service.selectedItems[0]);
        this.notFoundApp = false;
      }
    });
  }

  submit() {
    if (this.disableSubmitButton) return;
    this.disableSubmitButton=true;
    return this.service
      .apiRequest('POST', `admin/${this.service.moduleName}/assign`, {
        [this.service.moduleName]: this.data.row ? [this.data.row.id] : this.service.selectedItems,
        applications: this.selectedApp,
      })
      .subscribe(
        (res: any) => {
          let msg = this.service.shared.translate.instant(this.service.cid + '.assignMsg');
          if (res && res.message) {
            msg = res.message;
          }
          this.service.shared.toastr.success(msg, this.service.shared.translate.instant('common.success'), {
            closeButton: true,
          });
          this.service.selectedItems = [];
          this.service.updateResources.next(true);
          this.matDialogRef.close();
        },
        (error: any) => {
          if (error.error && error.error.message) {
            this.service.shared.toastr.error(error.error.message, '', {
              closeButton: true,
            });
          }
        },
      );
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  selectApp(e: any, appId: string) {
    this.disableSubmitButton = false;

    if (e.checked == true) {
      this.selectedApp.push(appId);
    } else {
      this.selectedApp = this.selectedApp.filter((id: string) => id !== appId);
    }
  }
}
